import { Accessor, createSignal, onCleanup, onMount } from "solid-js";

const DESKTOP_MIN_WIDTH_PX = 768;

export function useIsDesktop(): Accessor<boolean> {
  const [isDesktop, setIsDesktop] = createSignal(false);

  onMount(() => {
    const mediaQuery = window.matchMedia(
      `(min-width: ${DESKTOP_MIN_WIDTH_PX}px)`
    );
    const update = () => setIsDesktop(mediaQuery.matches);
    update();
    mediaQuery.addEventListener("change", update);
    onCleanup(() => mediaQuery.removeEventListener("change", update));
  });

  return isDesktop;
}
